// Shared NxHUB cache-key builders. These endpoints are cookie-auth/org-scoped;
// organizationId partitions the client cache only and is not sent on the wire.

// Root segments, exported so broad invalidation prefixes stay in lockstep with the builders
// (a hand-typed literal elsewhere would silently stop matching if a key were ever renamed).
export const NXHUB_VOICE_SUBSCRIPTIONS_KEY = 'nxhub-voice-subscriptions';
export const NXHUB_ALL_DEVICES_KEY = 'nxhub-all-devices';

export const voiceSubscriptionsQueryKey = (
    organizationId: string | undefined,
    subscriberDeviceSerial: string,
) => [NXHUB_VOICE_SUBSCRIPTIONS_KEY, organizationId ?? '', subscriberDeviceSerial];

export const allNxHubDevicesQueryKey = (organizationId: string | undefined) =>
    [NXHUB_ALL_DEVICES_KEY, organizationId ?? ''];

export const alertHistoryQueryKey = (organizationId: string | undefined) =>
    ['nxhub-alert-history', organizationId ?? ''];

export const voiceMessageHistoryQueryKey = (organizationId: string | undefined) =>
    ['nxhub-voice-message-history', organizationId ?? ''];

export const speakerProfilesQueryKey = (organizationId: string | undefined) =>
    ['nxhub-speaker-profiles', organizationId ?? ''];

export const speakerProfileSampleQueryKey = (
    organizationId: string | undefined,
    speakerProfileId: string,
) => ['nxhub-speaker-profile-sample', organizationId ?? '', speakerProfileId];
